/* eslint-disable sort-keys-fix/sort-keys-fix, typescript-sort-keys/interface, camelcase */
/*
 * This code is generated by ../../../scripts/generateSchemas.ts.
 * Do not adapt manually. Instead run 'yarn generate'.
 *
 * Source: ../../types/prompting-exercise/v0.ts
 */

import { createValidator } from '../../helpers/validator';
export const PromptingExerciseV0Schema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    assistantId: {
      type: 'string',
      title: 'Assistant ID',
      description: 'The ID of the assistant which the user will interact with. It should begin with `asst_`.',
      pattern: '^asst_.*'
    },
    opening: {
      anyOf: [{
        type: 'string',
        title: 'Opening Message'
      }, {
        type: 'object',
        properties: {
          message: {
            type: 'string',
            title: 'Opening Message',
            default: '',
            description: 'The opening message of the conversation'
          },
          userPrompt: {
            type: 'string',
            title: 'Opening User Prompt',
            default: '',
            description: 'The opening prompt that the user sends in the chat'
          },
          chatResponse: {
            type: 'string',
            title: 'Opening Chat Response',
            default: '',
            description: 'The response that the chat sends to the opening user prompt.'
          }
        },
        required: ['message', 'userPrompt', 'chatResponse'],
        title: 'Opening Conversation'
      }],
      title: 'Opening Type',
      description: 'The type of opening in the chat. It can either be an Opening Message or an OpeningConversation'
    },
    promptingScoreThreshold: {
      type: 'number',
      title: 'Prompting Score Threshold',
      description: 'The prompting score threshold (out of 100), after which the student passes the SCT.',
      default: 80,
      minimum: 0,
      maximum: 100
    },
    assignment: {
      type: 'string'
    },
    instructions: {
      type: ['string', 'null'],
      default: null
    },
    contextCriteria: {
      type: 'array',
      items: {
        type: 'string'
      },
      title: 'Context Criteria',
      description: 'The context criteria that the validator should check',
      minItems: 1
    },
    taskCriteria: {
      type: 'array',
      items: {
        type: 'string'
      },
      title: 'Task Criteria',
      description: 'The task criteria that the validator should check',
      minItems: 1
    },
    idealNumberOfWords: {
      type: 'number',
      title: 'Ideal Number of Words',
      description: 'The ideal number of words for the user prompt. The validator will use this value to check the conciseness score',
      minimum: 0
    },
    successMessage: {
      type: 'string',
      title: 'Success message',
      description: 'The message to display when the exercise is successfully completed'
    },
    solutionConversations: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          conversation: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                userPrompt: {
                  type: 'string',
                  title: 'User Prompt',
                  description: 'The user prompt.',
                  maxLength: 2000
                },
                aiResponse: {
                  type: 'string',
                  title: 'AI Response',
                  description: 'The AI response. This should be valid markdown. Keep in mind that less verbose content is more engaging.',
                  maxLength: 2000
                }
              },
              required: ['userPrompt', 'aiResponse']
            },
            title: 'Conversation',
            description: 'A single solution conversation.',
            minItems: 1
          }
        },
        required: ['conversation']
      },
      title: 'Solution Conversations',
      description: "The possible solution conversations. It's best to provide multiple conversations to show the variety of possible solutions. Up to 3 conversations possible.",
      minItems: 1,
      maxItems: 3
    },
    promptingFallbacks: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          prompt: {
            type: 'string',
            title: 'Prompt',
            default: 'A prompt',
            description: 'Possible prompt choice.'
          },
          response: {
            type: 'string',
            title: 'AI Response',
            default: 'A response',
            description: 'The preset response for this prompt.'
          },
          outputValidation: {
            type: 'boolean',
            title: 'Output Validation',
            default: false,
            description: 'Whether this prompt passes the output validation or not.'
          },
          feedback: {
            type: 'string',
            title: 'Prompt Feedback',
            default: '',
            description: 'The feedback message for this prompt.'
          },
          promptingScore: {
            type: 'object',
            properties: {
              contextScore: {
                type: 'number',
                title: 'Context Score',
                description: 'The score for the context of the prompt.'
              },
              taskScore: {
                type: 'number',
                title: 'Task Score',
                description: 'The score for the task of the prompt.'
              },
              concisenessScore: {
                type: 'number',
                title: 'Conciseness Score',
                description: 'The score for the conciseness of the prompt.'
              }
            },
            required: ['contextScore', 'taskScore', 'concisenessScore'],
            title: 'Prompting Score',
            description: 'The prompting score for this prompt.'
          }
        },
        required: ['prompt', 'response', 'outputValidation', 'feedback', 'promptingScore']
      },
      title: 'Prompting Fallbacks',
      description: 'The prompt fallbacks that should be used in the simulator',
      minItems: 2
    },
    useSimulator: {
      type: 'boolean',
      title: 'Use Simulator',
      default: false,
      description: 'Enable/disable use of ChatGPT.'
    },
    customGptTitle: {
      type: 'string',
      title: 'Custom GPT Title',
      default: 'ChatGPT',
      description: 'The custom title of the GPT'
    },
    poweredBy: {
      anyOf: [{
        type: 'object',
        properties: {
          poweredByType: {
            type: 'string',
            enum: ['OpenAI'],
            default: 'OpenAI'
          }
        },
        required: ['poweredByType'],
        title: 'OpenAI'
      }, {
        type: 'object',
        properties: {
          poweredByType: {
            type: 'string',
            enum: ['Empty'],
            default: 'Empty'
          }
        },
        required: ['poweredByType'],
        title: 'Empty'
      }, {
        type: 'object',
        properties: {
          poweredByType: {
            type: 'string',
            enum: ['Custom'],
            default: 'Custom'
          },
          poweredByText: {
            type: 'string',
            default: '',
            description: 'Sets the custom powered by field'
          }
        },
        required: ['poweredByType', 'poweredByText'],
        title: 'Custom'
      }],
      title: 'Custom Powered By',
      description: 'The custom "powered by" text'
    },
    iconUrl: {
      type: 'string',
      title: 'Custom Icon URL',
      description: 'The URL of the chat icon. Leave empty for default.',
      pattern: '(^$|^https://assets.datacamp.com/.*)'
    },
    title: {
      type: 'string'
    },
    xp: {
      type: 'number'
    },
    course_id: {
      type: 'number'
    },
    chapter_id: {
      type: 'number'
    }
  },
  required: ['assignment', 'assistantId', 'chapter_id', 'contextCriteria', 'course_id', 'customGptTitle', 'idealNumberOfWords', 'instructions', 'opening', 'poweredBy', 'promptingFallbacks', 'promptingScoreThreshold', 'solutionConversations', 'successMessage', 'taskCriteria', 'title', 'useSimulator', 'xp'],
  definitions: {}
};
export const isValidPromptingExerciseV0 = createValidator(PromptingExerciseV0Schema);
export const PromptingExerciseV0Definition = {
  schema: PromptingExerciseV0Schema,
  validate: isValidPromptingExerciseV0
};